/**
 * @file 兜底页controller
 */
import { openOneLink } from '@/utils/onelink-lib'
import { Tracker } from '@/utils/event-lib'
import { PORTAL_URL } from '@/types'
import { Ref } from 'vue'
export default (model?: { textGroup: Ref }) => {
  const mounted = () => model?.textGroup.value.track()
  return {
    mounted,
    // 打开官网
    openPortal() {
      location.href = PORTAL_URL
    },
    // 打开APP
    openApp() {
      model?.textGroup.value.track(false)
      Tracker.trackWithMedia(2006)
      openOneLink()
    },
  }
}
